import type { PropsWithChildren } from 'react';
import { lazy } from 'react';

export const LazyStripeElementsProvider = window.wirechunk.stripePK
  ? lazy(() => import('./components/stripe-elements-provider.tsx'))
  : ({ children }: PropsWithChildren) => children;
